var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 177.318C132.656 177.318 167.235 142.739 167.235 100.083C167.235 57.4272 132.656 22.848 90 22.848C47.3443 22.848 12.7651 57.4272 12.7651 100.083C12.7651 142.739 47.3443 177.318 90 177.318Z",
    fill: "#F7EDF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.812 160.585C106.812 158.235 96.3275 156.327 83.3945 156.327C70.4614 156.327 59.9788 158.235 59.9788 160.585C59.9788 162.935 70.4614 164.833 83.3945 164.833C96.3275 164.833 106.812 162.937 106.812 160.585Z",
    fill: "#852E62",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2688 143.078H75.3774V153.213H92.2688V143.078Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2688 143.078H75.3774V153.213H92.2688V143.078Z",
    stroke: "#852E62",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.783 159.969H61.8633C61.8633 158.177 62.5754 156.458 63.8425 155.19C65.1101 153.923 66.8292 153.211 68.6213 153.211H99.0249C100.817 153.211 102.536 153.923 103.804 155.19C105.071 156.458 105.783 158.177 105.783 159.969Z",
    fill: "white",
    stroke: "#852E62",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.743 65.3774H39.9036C37.6634 65.3774 35.5154 66.2671 33.9315 67.8511C32.3475 69.435 31.4578 71.583 31.4578 73.8232V129.564H136.188V73.8212C136.188 71.5816 135.298 69.4337 133.714 67.8504C132.13 66.267 129.982 65.3774 127.743 65.3774Z",
    fill: "#EB9DCB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.743 65.3774H39.9036C37.6634 65.3774 35.5154 66.2671 33.9315 67.8511C32.3475 69.435 31.4578 71.583 31.4578 73.8232V129.564H136.188V73.8212C136.188 71.5816 135.298 69.4337 133.714 67.8504C132.13 66.267 129.982 65.3774 127.743 65.3774Z",
    stroke: "#852E62",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M127.743 143.078C129.983 143.078 132.131 142.188 133.715 140.604C135.299 139.02 136.189 136.872 136.189 134.632V129.564H31.4578V134.632C31.4578 136.872 32.3475 139.02 33.9315 140.604C35.5154 142.188 37.6634 143.078 39.9036 143.078H127.743Z",
    fill: "white",
    stroke: "#852E62",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8213 133.848C83.332 133.848 82.8535 133.993 82.4463 134.264C82.0393 134.536 81.7219 134.922 81.5345 135.374C81.347 135.826 81.298 136.324 81.3933 136.804C81.4887 137.284 81.7242 137.725 82.0703 138.071C82.4164 138.417 82.8574 138.652 83.3371 138.748C83.8172 138.843 84.3147 138.794 84.7668 138.606C85.2187 138.419 85.6051 138.102 85.8767 137.695C86.1482 137.288 86.2931 136.809 86.2928 136.32C86.2922 135.664 86.0317 135.036 85.5682 134.573C85.1049 134.109 84.4765 133.849 83.8213 133.848Z",
    fill: "white",
    stroke: "#852E62",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.48 48.3452C109.135 51.4176 104.605 55.7279 101.272 60.9138C97.9378 66.0998 95.8974 72.0102 95.3214 78.1483C93.3694 97.6772 112.657 100.803 116.609 90.9209C120.867 80.2762 101.707 69.6332 86.8063 78.1483C71.9058 86.6634 71.9038 105.821 71.9038 105.821",
    stroke: "#852E62",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "9 5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M156.241 3.8656L99.6157 29.0326C99.1372 29.2459 98.7366 29.602 98.4682 30.0519C98.2001 30.502 98.0775 31.0236 98.1172 31.5459C98.1568 32.0682 98.357 32.5658 98.6903 32.9698C99.0235 33.3739 99.4737 33.6653 99.9788 33.8037L121.039 39.5462L136.007 60.9365C136.274 61.3178 136.641 61.6184 137.067 61.8055C137.493 61.9927 137.963 62.0591 138.424 61.9975C138.886 61.9358 139.321 61.7487 139.684 61.4565C140.046 61.164 140.321 60.7779 140.479 60.3399L159.662 7.04772C159.83 6.57941 159.857 6.07207 159.74 5.58861C159.623 5.10498 159.366 4.66661 159.001 4.32785C158.637 3.98891 158.181 3.76456 157.69 3.68223C157.199 3.60008 156.695 3.66388 156.241 3.8656Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M121.039 39.5462V56.8005C121.039 57.0517 121.114 57.2971 121.253 57.5059C121.393 57.7146 121.591 57.8771 121.823 57.9734C122.055 58.0694 122.311 58.0945 122.557 58.0455C122.803 57.9967 123.03 57.8759 123.207 57.6984L129.405 51.4983",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121.039 39.5462V56.8005C121.039 57.0517 121.114 57.2971 121.253 57.5059C121.393 57.7146 121.591 57.8771 121.823 57.9734C122.055 58.0694 122.311 58.0945 122.557 58.0455C122.803 57.9967 123.03 57.8759 123.207 57.6984L129.405 51.4983",
    stroke: "#852E62",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.039 39.5462L158.861 4.20544",
    stroke: "#852E62",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M156.241 3.8656L99.6157 29.0326C99.1372 29.2459 98.7366 29.602 98.4682 30.0519C98.2001 30.502 98.0775 31.0236 98.1172 31.5459C98.1568 32.0682 98.357 32.5658 98.6903 32.9698C99.0235 33.3739 99.4737 33.6653 99.9788 33.8037L121.039 39.5462L136.007 60.9365C136.274 61.3178 136.641 61.6184 137.067 61.8055C137.493 61.9927 137.963 62.0591 138.424 61.9975C138.886 61.9358 139.321 61.7487 139.684 61.4565C140.046 61.164 140.321 60.7779 140.479 60.3399L159.662 7.04772C159.83 6.57941 159.857 6.07207 159.74 5.58861C159.623 5.10498 159.366 4.66661 159.001 4.32785C158.637 3.98891 158.181 3.76456 157.69 3.68223C157.199 3.60008 156.695 3.66388 156.241 3.8656Z",
    stroke: "#852E62",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.b6903654b9385238653a26a59da1e2e0.svg";
export { ForwardRef as ReactComponent };